import { render, staticRenderFns } from "./HomeViewDept.vue?vue&type=template&id=0255c3e8&scoped=true"
import script from "./HomeViewDept.vue?vue&type=script&lang=js"
export * from "./HomeViewDept.vue?vue&type=script&lang=js"
import style0 from "./HomeViewDept.vue?vue&type=style&index=0&id=0255c3e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255c3e8",
  null
  
)

export default component.exports